/** Recognize only new versioned product rows. Legacy history stays literal. */
export interface ChatSystemCopy {
 version:1;
 kind:'tracking.created'|'tracking.updated'|'tracking.removed';
 actor_name:string;
 changes:{field:'title'|'status'|'priority'|'assignee'|'due';value:string|null}[];
}
const record=(v:unknown):v is Record<string,unknown>=>!!v&&typeof v==='object'&&!Array.isArray(v);
export function readSystemCopy(value:unknown,isTimestamp:(v:unknown)=>v is string,fail:()=>never):ChatSystemCopy|undefined{
 if(!record(value)||value.version!==1||!['tracking.created','tracking.updated','tracking.removed'].includes(String(value.kind)))return;
 if(typeof value.actor_name!=='string'||!Array.isArray(value.changes)||value.changes.length>5)fail();
 const seen=new Set<string>();
 const changes=value.changes.map(change=>{
  if(!record(change)||!['title','status','priority','assignee','due'].includes(String(change.field))||seen.has(change.field as string)||change.value!==null&&typeof change.value!=='string')fail();
  const field=change.field as ChatSystemCopy['changes'][number]['field'];seen.add(field);
  if((field==='title'||field==='status'||field==='priority')&&change.value===null||field==='status'&&!['open','in_progress','resolved'].includes(String(change.value))||field==='priority'&&!['low','normal','high'].includes(String(change.value))||field==='due'&&change.value!==null&&!isTimestamp(change.value))fail();
  return {field,value:change.value as string|null};
 });
 return {version:1,kind:value.kind as ChatSystemCopy['kind'],actor_name:value.actor_name,changes};
}
